import { Component, OnInit } from '@angular/core';
import { HttpService } from '../../../shared/http.service';
import {AlertService} from '../../../shared/alert.service';

@Component({
  selector: 'app-list-categories',
  templateUrl: './list-categories.component.html',
  styleUrls: ['./list-categories.component.scss']
})
export class ListCategoriesComponent implements OnInit {

  hasDataTables = true;
  entity = 'mailchimp';
  title = 'Listas Newsletter';
  lists = {};
  listsReady = false;
  actions = true;
  prevPath = 'list/';

  // [api param, column name, isSortable]
  columns = [
    // ['email', 'Correo electrónico', false], // userid.instituteName
    ['name', 'Nombre', false], // userid.contactName
    ['member_count', 'Suscriptos', false],
    ['open_rate', 'Ratio aperturas', false],
    ['click_rate', 'Ratio clicks', false],
  ];

  // [name, table header, isVisible]
  actionColumns = [
    ['highlight', 'Destacar', false],
    ['edit', 'Editar', true],
    ['delete', 'Eliminar', true]
  ];

  msg = {
    'delete': 'Lista borrada exitosamente',
    'error': 'Ocurrió un error inesperado'
  };


  constructor(
    private httpService: HttpService,
    private alertService: AlertService
  ) { }

  ngOnInit() {
    this.getAllLists();
  }

  getAllLists() {
    this.httpService.getRaw('/MailChimp/List', [])
      .subscribe(
        mailchimpListResponse => {
          this.lists['objects'] = [];
          for (let list of mailchimpListResponse['lists']) {
            let item = {};
            item['id'] = list['id'];
            item['name'] = list.name;
            item['member_count'] = list.stats.member_count;
            item['open_rate'] = list.stats.open_rate;
            item['click_rate'] = list.stats.click_rate;
            this.lists['objects'].push(item);
          }
          this.lists['length'] = mailchimpListResponse['total_items'];
          this.lists['pagination'] = 100;
          this.lists['offset'] = 0;
          this.listsReady = true;
        }
      );
  }

  delete(value) {
    this.listsReady = false;
    this.httpService.delete('/MailChimp/List/', value)
      .subscribe(
        updateResponse => {
          this.getAllLists();
          this.alertService.success(this.msg['delete']);
        },
        error => {
          this.alertService.error(this.msg['error']);
        }
      );
  }

}




// WEBPACK FOOTER //
// ./src/app/mailchimp/list/list-categories/list-categories.component.ts